import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=73b143c8&scoped=true"
import script from "./Agent.vue?vue&type=script&lang=js"
export * from "./Agent.vue?vue&type=script&lang=js"
import style0 from "./Agent.vue?vue&type=style&index=0&id=73b143c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b143c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b143c8')) {
      api.createRecord('73b143c8', component.options)
    } else {
      api.reload('73b143c8', component.options)
    }
    module.hot.accept("./Agent.vue?vue&type=template&id=73b143c8&scoped=true", function () {
      api.rerender('73b143c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/agent/Agent.vue"
export default component.exports